<div class="">
  @if (!error) {
    @if (ticket) {
      <div class="d-flex flex-column pb-2 pt-4 pe-0 pe-md-3 ps-0 ps-md-3 container">
        <div>
          <app-breadcrumb [previousRoute]="{name:'Mes tickets d\'assistance', route:'/tickets'}"
          currentRouteName="N° ticket {{ticket.number}}"></app-breadcrumb>
          <div class="d-flex justify-content-between align-items-center pt-3 grid-gap-05rem">
            <div class="d-flex align-items-center">
              @if (ticket.state.startsWith('4')) {
                <app-badge class="me-2" [label]="closedLabel"></app-badge>
              }
              <h1 class="m-0 p-md-0 pt-0 pb-0 d-inline-block position-relative">N°<span class="d-none d-md-inline-block">&nbsp;ticket&nbsp;</span>{{ ticket.number }}
            - {{ ticket.title }}</h1>
          </div>
          <div class="text-nowrap">
            <fa-icon [ngbPopover]="popContent" size="lg" popoverClass="mobile-popover" class="d-md-none pe-2 text-info"
            icon="question-circle"></fa-icon>
            <ng-template #popContent>
              <ul class="list-unstyled p-2 m-0">
                <li>Ticket N° : {{ ticket.number }}</li>
                <li>État : {{ ticket.state | statedisplay }}</li>
                <li>Pour : {{ ticket.queue }}</li>
                <li>Produit :
                  <app-badge [label]="getCategoryFromSlug(ticket.product)"></app-badge>
                </li>
                <li>Version : {{ ticket.version | version }}</li>
                <li>Version d'intégration : {{ ticket.versionIntegration | versionintegration }}</li>
                <li>Service : {{ ticket.service }}</li>
                <li>Niveau de priorité : {{ ticket.sla }}</li>
                <li>Propriétaire : {{ ticket.owner }}</li>
                <li>Responsable : {{ ticket.responsible }}</li>
              </ul>
            </ng-template>
          </div>
        </div>
        <div class="d-none d-md-flex mt-1 grid-gap-05rem justify-content-between">
          <div class="d-flex grid-gap-05rem">
            <button class="btn btn-outline-info" (click)="goBack()">
              <fa-icon icon="arrow-left"></fa-icon>
              Retour
            </button>
            <button class="btn btn-outline-primary" [ngbPopover]="popContent" placement="bottom-right">
              <fa-icon icon="question-circle"></fa-icon>
              <span class="d-inline-block">&nbsp;Voir les informations</span>
            </button>
          </div>
          <div class="d-flex grid-gap-05rem">
            @if (showAllButton) {
              <button class=" btn btn-outline-primary" (click)="showAll()">
                <fa-icon icon="plus-square"></fa-icon>
                Tout déplier
              </button>
            }
            @if (!showAllButton) {
              <button class="btn btn-outline-primary" (click)="hideAll()">
                <fa-icon icon="minus-square"></fa-icon>
                Tout replier
              </button>
            }
          </div>
        </div>
      </div>
      <div>
        @for (article of ticket.articles; track article; let index = $index) {
          <app-ticket-article [article]="article"
            [reduced]="hideArticle[index]" (reducedChange)="setReduced(index)"
          [ticketId]="ticket.number"></app-ticket-article>
        }
        <div [(ngbCollapse)]="hideResponse" [animation]="false" class="position-relative ps-6" (shown)="scrollBottom()">
          @if (ticket.articles[ticket.articles.length - 1].cc; as cc) {
            <div>
              @if (cc.length > 0) {
                <div class="text-light-grey pb-2">Copie à : {{ cc.join('; ') }}</div>
              } @else {
              }
            </div>
          } @else {
          }
          <ng-template #nocc></ng-template>
          <label class="fw-bold req-star" for="response">Texte</label>
          <app-angular-editor (paste)="detectBadImage($event)" name="response" id="response"
            [config]="{ editable: true, sanitize: false, fonts: [{class: 'ubuntu', name:'Ubuntu'}], minHeight: '15rem' }"
          [(ngModel)]="response.body"></app-angular-editor>
          <div class="pt-3">
            <app-upload-file [(sendedFiles)]="sendedFiles"></app-upload-file>
          </div>
        </div>
        <app-mobile-response class="d-md-none" [(hide)]="hideMobileResponse"
          (response)="response.body = $event.body; doUpdate(false, false, $event.filesIds)"
          (responseClose)="response.body = $event.body; doUpdate(true, false, $event.filesIds)"
          (responseRelance)="response.body = $event.body; doUpdate(false, true, $event.filesIds)"
        ></app-mobile-response>
      </div>
      <div class="d-flex d-md-block justify-content-center mb-2">
        @if (ticket.state.startsWith('4')) {
          <span class="alert alert-info float-end">
            <fa-icon icon="info-circle"></fa-icon>
            Ce ticket est clos
          </span>
        }
        <button class="btn btn-primary float-end d-inline-block d-md-none"
          [hidden]="ticket.state.startsWith('4') || !hideMobileResponse" (click)="hideMobileResponse = false">
          <fa-icon icon="paper-plane"></fa-icon>
          Répondre
        </button>
        <button class="btn btn-primary float-end d-none d-md-inline-block"
          [hidden]="ticket.state.startsWith('4') || !hideResponse" (click)="hideResponse = false">
          <fa-icon icon="paper-plane"></fa-icon>
          Répondre
        </button>
        @if (!hideResponse) {
          <div class="d-none d-md-block">
            <button class="btn btn-primary float-end" (click)="updateTicket(false, false)" [disabled]="!response.body || sendedFilesNotFinished()">
              <fa-icon icon="share"></fa-icon>
              Répondre
            </button>
            <button class="btn btn-outline-warning float-end me-3" [disabled]="!response.body || sendedFilesNotFinished()" (click)="reviveTicket()">
              <fa-icon icon="reply-all" flip="horizontal"></fa-icon>
              Relancer
            </button>
            <button class="btn btn-outline-success float-end me-3" [disabled]="!response.body || sendedFilesNotFinished()" (click)="closeTicket()">
              <fa-icon icon="check"></fa-icon>
              Répondre et clore
            </button>
            <app-cancel-button class="float-end me-3" (click)="hideResponse = true"></app-cancel-button>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="pt-4 container">
      <app-breadcrumb [previousRoute]="{name:'Mes tickets d\'assistance', route:'/tickets'}"
      currentRouteName="Récupération du ticket en cours ..."></app-breadcrumb>
      <div class="pt-5">
        @if (updating) {
          <div class="container text-info pb-5 text-center">
            Envoi de la réponse en cours, merci de ne pas fermer cette fenêtre
          </div>
        }
        <ls-spinner/>
      </div>
    </div>
  }
} @else {
  <div class="pt-4 container">
    <app-breadcrumb [previousRoute]="{name:'Mes tickets d\'assistance', route:'/tickets'}"
    currentRouteName="N° ticket {{ticket.number}}"></app-breadcrumb>
    <div class="d-flex align-items-center">
      <span class="alert alert-danger">
        Impossible de récupérer le ticket
      </span>
    </div>
  </div>
}


<ng-template #loading>
  <div class="pt-4 container">
    <app-breadcrumb [previousRoute]="{name:'Mes tickets d\'assistance', route:'/tickets'}"
    currentRouteName="Récupération du ticket en cours ..."></app-breadcrumb>
    <div class="pt-5">
      @if (updating) {
        <div class="container text-info pb-5 text-center">
          Envoi de la réponse en cours, merci de ne pas fermer cette fenêtre
        </div>
      }
      <ls-spinner/>
    </div>
  </div>
</ng-template>

<ng-template #noticket>
  <div class="pt-4 container">
    <app-breadcrumb [previousRoute]="{name:'Mes tickets d\'assistance', route:'/tickets'}"
    currentRouteName="N° ticket {{ticket.number}}"></app-breadcrumb>
    <div class="d-flex align-items-center">
      <span class="alert alert-danger">
        Impossible de récupérer le ticket
      </span>
    </div>
  </div>
</ng-template>
</div>

<ng-template #confirmclose let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-delete-title">
      Clore le ticket
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
    </button>
  </div>
  <div class="modal-body">
    <div>Cette action est définitive.</div>
    <div>Une fois le ticket clos, il ne sera plus possible d'y répondre et vous ne recevrez pas de réponse à votre
      demande.
    </div>
  </div>
  <div class="modal-footer">
    <app-cancel-button (click)="modal.dismiss()"></app-cancel-button>
    <button class="btn btn-outline-success" (click)="modal.close('Save click')">
      <fa-icon icon="check"></fa-icon>
      Répondre et clore
    </button>
  </div>
</ng-template>

<ng-template #confirmrevive let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-revive-title">
      Relancer le ticket
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
    </button>
  </div>
  <div class="modal-body">
    <div>Attention, la relance n'est à utiliser que si la demande est urgente et la situation bloquée en contexte de
      production.
    </div>
  </div>
  <div class="modal-footer">
    <app-cancel-button (click)="modal.dismiss()"></app-cancel-button>
    <button class="btn btn-outline-warning" (click)="modal.close('Save click')">
      <fa-icon icon="reply-all" flip="horizontal"></fa-icon>
      Relancer
    </button>
  </div>
</ng-template>
